module.exports = __webpack_public_path__ + "static/img/document-icon.44c36b16.svg";